export const DISPLAY_LANGUAGE_COOKIE = 'display-language';
export const CONTENT_LANGUAGES_COOKIE = 'content-language';
export const XACCESS_AUTHORIZATION_COOKIE = 'xaccesstoken';
export const X_Z5_GUEST_TOKEN_COOKIE = 'guestToken';
export const USER_TYPE_COOKIE = 'user-type';
export const PHPSESSID = 'PHPSESSID'; // reset coockie for Twitter logout
export const COUNTRY = 'country';
export const DROPDOWN_COUNTRY = 'dropDownCountry';
export const HELP_META = 'help_meta';
export const LAST_SAVED_TIME = 'lastSavedTime';
export const STATE = 'state';
export const PARTNER = 'partner';
export const WEBVIEW = 'webview';
export const SAMSUNG_LOGIN = 'samsungLogin';
export const ZEE5_USERNAME = 'zee5_username';
export const GALAXYID = 'galaxyId';
export const MANDATORY_REGISTRATION_API_FAILURE =
  'mandatoryRegistrationApiFailure';
export const PAYMENT_PROVIDER = 'paymentProvider';
export const SSO_TOKEN = 'ssoToken';
export const AF_USER_ID = 'afUserId';
export const PLAN_ID = 'planID';
export const FBP = '_fbp';
export const FBC = '_fbc';
export const FB_LOGIN_ID = 'fb_login_id';
